import React from 'react';
import { ShieldAlert } from 'lucide-react';

/**
 * IdleWarningModal — shown ~60s before auto-logout (Vague 97.2).
 *
 * Self-contained (no Radix dialog) so it renders even when the rest of the app
 * is in a frozen state (e.g. user lost focus inside a long modal). Uses a
 * portal-like fixed overlay with very high z-index to ensure visibility.
 */
export default function IdleWarningModal({ open, remaining, onStay, onLogout }) {
  if (!open) return null;
  return (
    <div
      data-testid="idle-warning-modal"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="idle-warning-title"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#1A1B2E]/55 backdrop-blur-sm p-4"
    >
      <div className="w-full max-w-[420px] rounded-2xl bg-white shadow-2xl border border-[#EFF0F6] p-6">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-10 h-10 rounded-xl bg-[#FEF3C7] text-[#92400E] flex items-center justify-center shrink-0">
            <ShieldAlert className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <h2 id="idle-warning-title" className="text-[16px] font-semibold text-[#1A1B2E]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Toujours là ?
            </h2>
            <p className="text-[13px] text-[#6B6C85] mt-0.5">
              Pour protéger vos données, votre session se fermera automatiquement.
            </p>
          </div>
        </div>

        <div data-testid="idle-warning-countdown" aria-live="polite" className="rounded-xl bg-[#EEF2FF] border border-[#C7D2FE] px-4 py-3 mb-4 text-center">
          <div className="text-[11.5px] font-semibold text-[#4F46E5] uppercase tracking-wide">Déconnexion automatique dans</div>
          <div className="text-[28px] font-bold text-[#4F46E5] mt-1 tabular-nums">{remaining}s</div>
        </div>

        <div className="flex gap-2">
          <button
            type="button"
            data-testid="idle-warning-logout"
            onClick={onLogout}
            className="flex-1 h-10 rounded-xl bg-white border border-[#EFF0F6] text-[#4A4B63] text-[13px] font-semibold hover:bg-[#F6F7FB] transition-colors"
          >
            Se déconnecter
          </button>
          <button
            type="button"
            data-testid="idle-warning-stay"
            onClick={onStay}
            autoFocus
            className="flex-1 h-10 rounded-xl brand-gradient text-white text-[13px] font-semibold hover:opacity-95 transition-opacity"
          >
            Je suis là
          </button>
        </div>
      </div>
    </div>
  );
}
